export const getTariffData = (camp) => {
  let bonuses, tariff, allGuestCount, discount, priceMin, priceMinWithoutDiscount;

  const apartments = camp.apartments;
  const complexPlacement = camp.complex_placement;

  if (complexPlacement) {
    bonuses = complexPlacement.total_bonuses;
    tariff = complexPlacement.items?.[0]?.tariff;
    allGuestCount = complexPlacement.total_guests;
    priceMin = complexPlacement?.suitable_price;
    priceMinWithoutDiscount = complexPlacement?.suitable_price_without_discount;
  } else if (apartments) {
    bonuses = apartments[0]?.bonuses;
    tariff = apartments[0]?.tariffs[0];
    allGuestCount = (tariff?.seats ?? 0) + (tariff?.seats_additional ?? 0) + (tariff?.child_count_no_seats ?? 0);
    discount = tariff?.discount;
  }

  priceMin ||= tariff?.calculated_price ?? null;
  priceMinWithoutDiscount ||= tariff?.calculated_price_without_discount ?? null;

  return {
    tariff,
    bonuses: bonuses ?? 0,
    priceMin,
    priceMinWithoutDiscount,
    allGuestCount,
    discount: discount ?? 0,
  };
};
